module.exports = __webpack_public_path__ + "img/6dc7feb.jpg";